import { SvgIconProps } from '@mui/material';

export const FeaturedIconShield = (props: SvgIconProps) => {
  return (
    <svg {...props} fill="none" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
      <circle cx="28" cy="28" fill="#F5F5FF" r="28" />
      <circle cx="28" cy="28" fill="#E7E7FC" r="20" />
      <path
        d="M25 27.5L27 29.5L31.5 25M36 28C36 32.9084 30.646 36.4784 28.698 37.6149C28.4766 37.744 28.3659 37.8086 28.2097 37.8421C28.0884 37.8681 27.9116 37.8681 27.7903 37.8421C27.6341 37.8086 27.5234 37.744 27.302 37.6149C25.354 36.4784 20 32.9084 20 28V23.2176C20 22.4181 20 22.0183 20.1308 21.6747C20.2463 21.3711 20.434 21.1003 20.6777 20.8855C20.9535 20.6424 21.3278 20.5021 22.0764 20.2213L27.4382 18.2107C27.6461 18.1327 27.75 18.0937 27.857 18.0783C27.9518 18.0646 28.0482 18.0646 28.143 18.0783C28.25 18.0937 28.3539 18.1327 28.5618 18.2107L33.9236 20.2213C34.6722 20.5021 35.0465 20.6424 35.3223 20.8855C35.566 21.1003 35.7537 21.3711 35.8692 21.6747C36 22.0183 36 22.4181 36 23.2176V28Z"
        stroke="#0909A2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};




